import React from "react"
import {
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
	CustomInput,
	CardHeader,
	UncontrolledButtonDropdown,
	Table,
	Input,
	Col,
	Row
} from "reactstrap"
import styles from "./EditablePlayersTable.module.scss"

function EditablePlayersTable({
	team,
	reverse,
	formationOptions,
	jerseyOptions,
	selectedJerseys,
	selectedFormation,
	setSelectedFormation,
	setJerseys,
	captainId,
	setCaptainId,
	positions,
	setPositions,
	setPlayerNumbers,
	hasPlayerNumbers,
	hasCaptain,
	isTennis,
	twoJerseyColors,
	oneJerseyColor,
	setSeparatePlayerJersey,
	selectedSeparatePlayerJersey
}) {
	const { players, name } = team

	const createRadio = (player) => {
		return (
			<td className={styles.centerChild}>
				<CustomInput
					id={`captain-${reverse}-${player.playerId}`}
					type="radio"
					checked={captainId == player.playerId}
					onClick={() => setCaptainId(player.playerId)}
					onChange={() => {}}
				/>
			</td>
		)
	}

	const createRow = (player, index) => {
		const { name, surname, _id, playerId } = player
		return (
			<tr key={`playerRow-${reverse}-${index}`}>
				{selectedFormation && (
					<td style={{ direction: "ltr", width: 100 }}>
						{createDropdown(
							selectedFormation.positions?.filter(
								(option) =>
									!Object.values(positions).includes(option) ||
									option == "Bench" ||
									option == "Bench-GK" ||
									option == "Nedostaje"
							),
							positions[player.playerId],
							"",
							(position) => {
								if (position == "Igrač Nedostaje") {
									const newPositions = { ...positions }
									delete newPositions[player.playerId]
									setPositions(newPositions)
								} else {
									setPositions({
										...positions,
										[player.playerId]: position,
									})
								}
							}
						)}
					</td>
				)}
				<td>
					{name} {surname}
				</td>
				{hasPlayerNumbers && (
					<td style={{ direction: "ltr", width: 100 }}>
						<Input
							type="number"
							bsSize="sm"
							// invalid={true}
							onChange={({ target }) =>
								setPlayerNumbers(
									target.value,
									player.playerId,
									reverse
								)
							}
						/>
					</td>
				)}
				{hasCaptain && createRadio(player)}
				{isTennis && (
					<td style={{ direction: "ltr", width: 100 }}>
						{createDropdown(
							["Izbaci", "U igri"],
							positions[playerId ?? _id],
							"",
							(position) => {
								if (position == "Izbaci") {
									const newPositions = { ...positions }
									delete newPositions[playerId ?? _id]
									setPositions(newPositions)
								} else {
									setPositions({
										...positions,
										[playerId ?? _id]: position,
									})
								}
							}
						)}
					</td>
				)}
			</tr>
		)
	}

	const createDropdown = (options, title, defaultTitle, setter, isBig) => {
		if (!options?.length) return <></>

		return (
			<UncontrolledButtonDropdown
				size={isBig ? "md" : "sm"}
				style={{ direction: "ltr" }}
			>
				<DropdownToggle color="primary" caret outline={!isBig}>
					{title ?? defaultTitle}
				</DropdownToggle>
				<DropdownMenu>
					{options.map((option, index) => (
						<DropdownItem
							key={`option-${reverse}-${title}-${index}`}
							onClick={() => setter(option)}
						>
							{option}
						</DropdownItem>
					))}
				</DropdownMenu>
			</UncontrolledButtonDropdown>
		)
	}

	const createJerseysDropdown = (options, title, defaultTitle, setter, isBig) => {
		return (
			<UncontrolledButtonDropdown
				size={isBig ? "md" : "sm"}
				style={{ direction: "ltr" }}
			>
				<DropdownToggle color="primary" caret outline={!isBig}>
					{title ?? defaultTitle}
				</DropdownToggle>
				<DropdownMenu>
					{options.map((option, index) => (
						<DropdownItem
							key={`option-${reverse}-${title}-${index}`}
							onClick={() => setter(option)}
						>
							{option.name}
						</DropdownItem>
					))}
				</DropdownMenu>
			</UncontrolledButtonDropdown>
		)
	}

	return (
		<div style={reverse ? { direction: "rtl" } : {}}>
			<CardHeader style={{ paddingBottom: 0 }}>
				<h1 className="m-0">{name}</h1>
			</CardHeader>
			<CardHeader>
				{formationOptions.length > 1 &&
					createDropdown(
						formationOptions,
						selectedFormation.formation,
						"Formacija",
						setSelectedFormation,
						true
					)}
			</CardHeader>
			{
				(twoJerseyColors || oneJerseyColor) &&
				<CardHeader>
					<h3>Odaberi boju dresova</h3>
					</CardHeader>
				
			}
			{
				oneJerseyColor &&
				<CardHeader className="pt-0">
				{
					createJerseysDropdown(
						jerseyOptions,
						selectedJerseys.name,
						"Boja dresova",
						setJerseys,
						true
					)
				}
			</CardHeader>
			}
		
			{
				twoJerseyColors && 
			
					<>
				<CardHeader className="pt-0">
				{
					createJerseysDropdown(
						jerseyOptions,
						selectedJerseys.name,
						"Boja dresova",
						setJerseys,
						true
					)
				}
			</CardHeader>
			
			
			<CardHeader className="pt-0">
			{
				createJerseysDropdown(
					jerseyOptions,
					selectedSeparatePlayerJersey.name,
					"Boja dresa zasebnog igrača",
					setSeparatePlayerJersey,
					true
				)
			}
		</CardHeader>
	
	</>
			}

		
			<Table>
				<thead>
					<tr>
						{selectedFormation && <th>Pozicija</th>}
						<th>Igrač</th>
						{hasPlayerNumbers && <th>Broj</th>}
						{hasCaptain && (
							<th className={styles.centerChild}>Kapetan</th>
						)}
						{isTennis && <th></th>}
					</tr>
				</thead>
				<tbody>
					{players
						.sort(function (a, b) {
							if (a.name.toLowerCase() < b.name.toLowerCase())
								return -1
							if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
							if (a.surname.toLowerCase() < b.surname.toLowerCase())
								return -1
							if (a.surname.toLowerCase() > b.surname.toLowerCase())
								return 1
							return 0
						})
						.map(createRow)}
				</tbody>
			</Table>
		</div>
	)
}

export default EditablePlayersTable
